import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { UpdateTask } from "../../../../../redux/team/action";
import ReactSelect from "react-select";
import TeamsUpdateTaskModel from "./TeamsUpdateTaskModel";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import downloadFiles from "../../../../Common/FilesRelevent/DownloadFiles";
import LabelgetRemaindays from "../../../../Common/CustomeLabel/LabelgetRemaindays";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";
import { getFileSize } from "../../../../../assests/extention/commonfunction";
import FileSizeDisplay from "../../../../Common/FileSizeDisplay";
import GetRemainOnlyDays from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainOnlyDays";

const statusOptions = [
  { value: "1", label: "Assigned" },
  { value: "2", label: "In Progress" },
  { value: "3", label: "Completed" },
  { value: "4", label: "Reopened" },
];

export default function TeamsViewDetailsModel({
  taskdetails,
  projectdetails,
  setviewModel,
  projectid,
  itemdata,
}) {
  const [loading, setLoading] = useState(false);
  const [statusIndex, setStatusIndex] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [taskModel, setTaskModel] = useState(false);
  const dispatch = useDispatch();

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    setStatusIndex(null);
    setStatusIndex(
      statusOptions?.find((item) => item.value == itemdata?.status)
    );
    if (itemdata?.status) {
      setStatusIndex(
        statusOptions?.find((item) => item.value == itemdata?.status)
      );
      setSelectedDate(itemdata?.due_date);
    }
  }, [itemdata, setviewModel]);

  const chagestatus = (status) => {
    setLoading(true);

    const data = {
      status: status,
      type: 3,
      id: itemdata?.id,
      team_project_id: projectid,
      reload: false,
    };
    dispatch(UpdateTask(data));
    setviewModel(false);
    setLoading(true);
  };

  const chagedate = (event) => {
    const selectedDate = event.target.value;
    setSelectedDate(selectedDate);
    const data = {
      due_date: selectedDate,
      type: 5,
      id: itemdata?.id,
      team_project_id: projectid,
      reload: false,
    };
    dispatch(UpdateTask(data));
    setviewModel(false);
  };

  const currentDate = new Date().toISOString().split("T")[0];
  return (
    <div className="modal-content">
      <a
        onClick={() => {
          setviewModel((state) => !state);
        }}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </a>
      <ModalBody>
        <div className="modal-body-first">
          <p className="breadcrumbs">
            <a onClick={() => setviewModel(false)}>
              {projectdetails?.title} &gt;
            </a>
            Task #{taskdetails?.title}
          </p>
          {profile.role_type == "4" && (
            <button className="btn" onClick={() => setTaskModel(true)}>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                alt=""
              />
            </button>
          )}
        </div>
        <div className="modal-body-second">
          <h6>Task Details </h6>
          <h2>{itemdata?.title}</h2>
          <div className="assignee">
            <h3>Assignee</h3>
            <div className="assignee-sec">
              <h4>
                <img
                  src={
                    itemdata?.profile_image
                      ? itemdata?.profile_image
                      : ProfilePic
                  }
                  alt=""
                />
                {itemdata?.first_name} {itemdata?.last_name}
              </h4>
              <ReactSelect
                options={statusOptions.filter((opt) => opt.value != statusIndex?.value)}
                placeholder="Select status"
                value={statusIndex}
                onChange={(option) => {
                  setStatusIndex(option);
                  chagestatus(option?.value);
                }}
              />
            </div>
            <div className="assignee">
              <h3>Deadline</h3>
              <div className="assignee-sec assignee-bottom">
                <div className="form-group">
                  <input
                    type="date"
                    disabled={profile && profile.role_type !== "4"}
                    value={selectedDate}
                    onChange={chagedate}
                    placeholder="Select a date"
                    min={currentDate}
                    className="form-control"
                  />
                </div>
                <p className="deadline-p">
                  <i className="fa-regular fa-clock" aria-hidden="true"></i>{" "}
                </p>
                {statusIndex?.value != 3 &&
                  <GetRemainOnlyDays enddate={itemdata?.due_date} />
                }

              </div>
            </div>
          </div>
          <h6>Description</h6>
          <CustomReactQuillDescription value={itemdata?.description} />

          {Array.isArray(itemdata.files) &&
            itemdata.files &&
            itemdata.files?.length > 0 && (
              <>
                <h6>Attachments</h6>
                {Array.isArray(itemdata?.files) &&
                  itemdata?.files?.map((item, index) => (
                    <div className="attachment-team">
                      <div className="attachment-left">
                        {/* <img src={item?.file} className="w-100 attach-img" alt="" /> */}
                        <DisplayFileProper item={item} className="w-100 attach-img" />
                        <div>
                          <h4>{item?.name}</h4>
                          <FileSizeDisplay filePath={item?.file} />
                        </div>
                      </div>
                      {/* <button
                        onClick={() => {
                          downloadFiles(item?.file);
                        }}
                        className="btn"
                      >
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
                          alt=""
                        />
                      </button> */}
                    </div>
                  ))}
              </>
            )}
        </div>
      </ModalBody>

      <Modal className="popupmodal yes-no" isOpen={taskModel}>
        <TeamsUpdateTaskModel
          setviewModel={setviewModel}
          projectid={projectid}
          setTaskModel={setTaskModel}
          itemdata={itemdata}
        />
      </Modal>
    </div>
  );
}
